import { FAILURE, REQUEST, SUCCESS } from 'utils/actionTypeUtil';
import { BASE_API_URL } from 'constants/apiUrl';
import axios from 'axios';

const apiUrl = `${BASE_API_URL}/user/authority`;

export const ACTION_TYPES = {
  FETCH_AUTHORITY_LIST: 'authority/FETCH_AUTHORITY_LIST',
  FETCH_AUTHORITY: 'authority/FETCH_AUTHORITY',
  CREATE_AUTHORITY: 'authority/CREATE_AUTHORITY',
  UPDATE_AUTHORITY: 'authority/UPDATE_AUTHORITY',
  DELETE_AUTHORITY: 'authority/DELETE_AUTHORITY',
  RESET: 'authority/RESET',
};

const initial = {
  loading: false,
  errorMessage: null,
  updating: false,
  updateSuccess: false,
  entities: [], //ent
  entity: {}, //defaultValue
  pageable: {
    sort: {
      sorted: false,
      unsorted: true,
      empty: true,
    },
    pageSize: 10,
    pageNumber: 0,
    offset: 0,
    paged: true,
    unpaged: false,
  },
  totalElements: 0,
  last: false,
  totalPages: 0,
  sort: {},
  first: true,
  numberOfElements: 0,
  size: 0,
  number: 0,
  empty: true,
};

// REDUCER
const authorityReducer = (state = initial, action) => {
  switch (action.type) {
    case REQUEST(ACTION_TYPES.FETCH_AUTHORITY_LIST):
    case REQUEST(ACTION_TYPES.FETCH_AUTHORITY):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        loading: true,
      };
    case REQUEST(ACTION_TYPES.CREATE_AUTHORITY):
    case REQUEST(ACTION_TYPES.UPDATE_AUTHORITY):
    case REQUEST(ACTION_TYPES.DELETE_AUTHORITY):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        updating: true,
      };
    case FAILURE(ACTION_TYPES.FETCH_AUTHORITY_LIST):
    case FAILURE(ACTION_TYPES.FETCH_AUTHORITY):
    case FAILURE(ACTION_TYPES.CREATE_AUTHORITY):
    case FAILURE(ACTION_TYPES.UPDATE_AUTHORITY):
    case FAILURE(ACTION_TYPES.DELETE_AUTHORITY):
      return {
        ...state,
        loading: false,
        updating: false,
        updateSuccess: false,
        errorMessage: action.payload.response,
      };
    case SUCCESS(ACTION_TYPES.FETCH_AUTHORITY_LIST):
      let res = action.payload.data;
      return {
        ...state,
        loading: false,
        entities: res.content,
        pageable: {
          sort: {
            sorted: res.pageable.sort.sorted,
            unsorted: res.pageable.sort.unsorted,
            empty: res.pageable.sort.empty,
          },
          pageSize: res.pageable.page_size,
          pageNumber: res.pageable.page_number,
          offset: res.pageable.offset,
          paged: res.pageable.paged,
          unpaged: res.pageable.unpaged,
        },
        totalElements: res.total_elements,
        last: res.last,
        totalPages: res.total_pages,
        sort: res.sort,
        first: res.first,
        numberOfElements: res.number_of_elements,
        size: res.size,
        number: res.number,
        empty: res.empty,
      };
    case SUCCESS(ACTION_TYPES.FETCH_AUTHORITY):
      return {
        ...state,
        loading: false,
        entity: action.payload.data,
      };
    case SUCCESS(ACTION_TYPES.CREATE_AUTHORITY):
    case SUCCESS(ACTION_TYPES.UPDATE_AUTHORITY):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: action.payload.data,
        successMessage: action.payload.meta,
      };
    case SUCCESS(ACTION_TYPES.DELETE_AUTHORITY):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: {},
      };
    case ACTION_TYPES.RESET:
      return { ...initial };
    default:
      return state;
  }
};

export default authorityReducer;

// ACTIONS

export const getEntities = (page, size, sort) => ({
  type: ACTION_TYPES.FETCH_AUTHORITY_LIST,
  payload: axios.get(apiUrl, {
    params: {
      page: undefined || page,
      size: undefined || size,
      sort: undefined || sort,
    },
  }),
});

export const getEntity = id => ({
  type: ACTION_TYPES.FETCH_AUTHORITY,
  payload: axios.get(`${apiUrl}/${id}`),
});

export const createEntity = entity => ({
  type: ACTION_TYPES.CREATE_AUTHORITY,
  payload: axios.post(apiUrl, entity),
  meta: { successMessage: `Berhasil simpan!` },
});

/* export const createEntity = entity => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.CREATE_AUTHORITY,
    payload: axios.post(apiUrl, entity),
    meta: { successMessage: `Berhasil simpan!` },
  });
  dispatch(getEntities());
  return result;
}; */

/* export const updateEntity = (entity, id) => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.UPDATE_AUTHORITY,
    payload: axios.patch(`${apiUrl}/${id}`, entity),
    meta: { successMessage: `Berhasil update!` },
  });
  dispatch(getEntities());
  return result;
}; */

export const updateEntity = (entity, id) => ({
  type: ACTION_TYPES.UPDATE_AUTHORITY,
  payload: axios.patch(`${apiUrl}/${id}`, entity),
  meta: { successMessage: `Berhasil update!` },
});

export const deleteEntity = (id, page, size, sort) => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.DELETE_AUTHORITY,
    payload: axios.delete(`${apiUrl}/${id}`),
    meta: { successMessage: `Berhasil hapus!`, errorMessage: 'Authority telah digunakan!' },
  });
  dispatch(getEntities(page, size, sort));
  return result;
};

export const reset = () => ({
  type: ACTION_TYPES.RESET,
});
